import React from "react";

import "./presentationSheetContent3.scss";
import "../../../styles/fontSizes.scss";
import Pdf from "SVG/pdfFile.svg";
//Necesita que el padre tenga positicionamiento relativo.
//Recibe el tipo de órbita, limitado a la implementación del estilo del componente dentro de su hoja de estilo
const PresentationSheetContent3 = ({
  title1,
  content1,
  content2,
  link1,
  link2,
}) => {
  return (
    <>
      <div
        className={`presentation-sheet-content-third__container font-size--2`}
      >
        <div className="presentation-sheet-content-third__first-section">
          <h1 className="presentation-sheet-content-third__title">{title1}</h1>
          <p className="presentation-sheet-content-third__text">{content1}</p>
        </div>
        <div className="presentation-sheet-content-third__bar" />
        <div className="presentation-sheet-content-third__second-section">
          <p className="presentation-sheet-content-third__text2">{content2}</p>
        </div>
        <div className="presentation-sheet-content-third__bar" />
        <div className="presentation-sheet-content-third__third-section">
          <div className="presentation-sheet-content-third__pdf-section">
            <img
              src={Pdf}
              alt=""
              className="presentation-sheet-content-third__pdf-image"
            />
            <a
              className="presentation-sheet-content-third__third-section-text"
              href={link1}
              target="_blank"
            >
              Reglamento
            </a>
          </div>
          <div className="presentation-sheet-content-third__pdf-section">
            <img
              src={Pdf}
              alt=""
              className="presentation-sheet-content-third__pdf-image"
            />
            <a
              className="presentation-sheet-content-third__third-section-text"
              href={link2}
              target="_blank"
            >
              Ficha de seguridad
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default PresentationSheetContent3;
